export enum Currency {
    EUR = 'EUR',
    CHF = 'CHF',
    PLN = 'PLN',
    CZK = 'CZK',
    ZL = 'ZL',
}

const SECONDARY_COUNTRY_CODES = ['be', 'at'] as const;
export const AVAILABLE_COUNTRY_CODES = ['de', 'it', 'ch', 'nl', 'pl', 'es', 'fr', 'cz', 'sk', 'pt'] as const;
export const COUNTRY_CODES = [...AVAILABLE_COUNTRY_CODES, ...SECONDARY_COUNTRY_CODES] as const;

export type HrefLangsDomains = {
    [key in (typeof SECONDARY_COUNTRY_CODES)[number]]?: string;
} & {
    [key in (typeof AVAILABLE_COUNTRY_CODES)[number]]: string;
};

export type SpeedCurveConfig =
    | {
          enabled: false;
          LUXId?: string;
      }
    | {
          enabled: true;
          LUXId: string;
      };

export interface AppAdjustTracker {
    android: string;
    ios: string;
}

export interface Config {
    aliceCookieRefreshUrl: string;
    climateNeutralLogoUrl: string;
    speedCurve: SpeedCurveConfig;
    buildPipelineId: string;
    buildVersion: string;
    shopApiBaseUrl: string;
    webBffBaseUrl: string;
    clubBffBaseUrl: string;
    clubApiBaseUrl: string;
    clubStaticHost: string;
    serverAPITimeoutInMS: number;
    serverRequestTimeOutInMS: number;
    serverAPIGenericTimeoutInMS: number;
    staticHost: string;
    staticCmsHost: string;
    bellaApiBaseUrl: string;
    gtmAccountId: string;
    clubGtmAccountId: string;
    facebookAppId: string;
    listingPageSize: number;
    currency: Currency;
    countryCode: string;
    currentCountry: CountryCode;
    allowedDeliveryCountry?: CountryCode[];
    klarna?: { minPrice: number; maxPrice: number; clientId: string };
    languages: { [key: string]: string };
    hrefLangsDomains: HrefLangsDomains;
    env: string;
    preconnectUrls: string[];
    shopToClubOverlayId: string;
    clubSignupOverlayId: string;
    hotjarId: string;
    shopSegmentWriteKey: string;
    clubSegmentWriteKey: string;
    segmentBaseCDNURL: string;
    lisaBaseUrl: string;
    bobBaseUrl: string;
    links: {
        clubBaseUrl: string;
        owwClubBasePath: string;
        clubB2B: string;
        clubPaths: {
            inspiration: string;
            products: string;
            sales: string;
            topmerken: string;
            b2b?: string;
            agbB2b?: string;
            dataProtection: string;
            agb: string;
            imprint: string;
            helpCenterUrl: string;
            helpCenterContactUrl: string;
            umweltUndEntsorgung?: string;
            helpCenterReviewsFaq?: string;
        };
        footerSeo: {
            [key: string]: {
                [key: string]: string;
            };
        };
        agbB2b?: string;
        b2b?: string;
        sustainability: string;
        insights: string;
        corporate: string;
        compliance?: string;
        url: string;
        facebook: string;
        instagram: string;
        pinterest: string;
        youtube: string;
        tiktok: string;
        apple: string;
        android: string;
        contact: string;
        press?: string;
        owwPress?: string;
        imprint: string;
        faq: string;
        brands: string;
        agb: string;
        career: string;
        dispute: string;
        legal: string;
        cookiePolicy: string;
        ODR: string;
        dataProtection: string;
        creditCheckPolicy: string;
        forgotPassword: string;
        home: string;
        cart: string;
        wishList: string;
        looks: string;
        login: string;
        logout: string;
        myAccount: string;
        myWishlist: string;
        myLooks: string;
        myOrders: string;
        myReviews: string;
        myCoupons: string;
        myEditAccount: string;
        myAddress: string;
        myNewsletter: string;
        myNotifications: string;
        respondentContact: string;
        clubReferAFriendPath: string;
        westwingCollection: string;
        helpCenterUrl: string;
        helpCenterContactUrl: string;
        helpCenterFreeReturn: string;
        helpCenter30DaysReturn: string;
        olapicUgcGallery: string;
        styleHub: string;
        umweltUndEntsorgung?: string;
        appsPromoPage: string;
        sales: string;
        helpCenterAssemblyService: string;
        shippingLinkPath: string;
        taxStrategy: {
            [key: string]: string;
        };
    };
    appAdjustTrackers: {
        small: AppAdjustTracker;
        smart: AppAdjustTracker;
        micro: AppAdjustTracker;
    };
    companyData: {
        contactPoint: {
            contactType: string;
        };
        hoursAvailable: {
            dayOfWeek: string[];
        }[];
    };
    availableCountryCodes: Record<(typeof AVAILABLE_COUNTRY_CODES)[number], string>;
}

export type Links = Config['links'];

export type CountryCode = (typeof COUNTRY_CODES)[number];

export enum Application {
    BELLA = 'bella',
    CLUB = 'club',
}

export default {};
